import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import HeaderTitle from '../../../components/HeaderTitle';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import swal from 'sweetalert';
import BackButton from '../../../components/BackButton';
import { Helmet } from 'react-helmet';
import ControlPage from '../../Auth/ControlPage';
import { hasMuhasebeRole, isAdmin } from '../../../utils/roleUtils';

function CreateCompanies() {
    const { type } = useParams();
    const navigate = useNavigate();

    const { token, role } = useSelector((state) => state.auth)
    const form = useForm();

    if (hasMuhasebeRole(role) && !isAdmin(role)) {
        return <ControlPage />
    }

    const saveCompany = (data) => {
        form.setValue('companyType', type);

        axios.post(`${process.env.REACT_APP_SERVICE_URL}/company`, {
            name: data.companyName,
            companyType: type
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then((response) => {
                console.log(response.data)
                swal("Firma başarıyla eklendi", {
                    icon: "success",
                });
                form.reset();
                navigate(-1)
            })
            .catch((error) => {
                console.error(error)
                swal("Firma eklenirken hata oluştu", {
                    icon: "error",
                });
            })

    }

    return (
        <div className='container-fluid'>
            <Helmet>
                <title>Firma Ekle</title>
                <meta name='description' content='Firma ekleme formu' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
            </Helmet>
            <HeaderTitle title="Firma Ekle" description="Firma ekleme formu" />

            <div className='row'>
                <div className='col-md-3'>
                    <div className='card'>
                        <div className='card-body'>
                            <BackButton />

                            <form className='mt-3' onSubmit={form.handleSubmit(saveCompany)}>
                                <div className='mb-3'>
                                    <label htmlFor='companyName' className='form-label'>Firma Adı</label>
                                    <input type='text' className='form-control' id='companyName' {...form.register('companyName')} />
                                </div>

                                <div className='mb-3'>
                                    <button type='submit' className='btn btn-dark btn-app btn-app--lg'>Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateCompanies